import { ErrorMessageStrategy } from '@shared/utils/interfaces';

export const vendorAssignFailStrategy: ErrorMessageStrategy = () => {
  return {
    translationKey: 'errors.vendortAssignFail',
  };
};
